import { Route, BrowserRouter as Router, Routes } from "react-router";
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import SignIn from "./pages/AuthPages/SignIn";
import Dashboard from "./pages/Dashboard";
import FormElements from "./pages/Forms/FormElements";
import NotFound from "./pages/OtherPage/NotFound";
import BasicTables from "./pages/Tables/BasicTables";
import Alerts from "./pages/UiElements/Alerts";
import Avatars from "./pages/UiElements/Avatars";
import Badges from "./pages/UiElements/Badges";
import Buttons from "./pages/UiElements/Buttons";
import Images from "./pages/UiElements/Images";
import Videos from "./pages/UiElements/Videos";
import UserProfiles from "./pages/UserProfiles";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Events from "./pages/Events";
import { useUserStore } from "./store/userStore";
import { useEffect } from "react";
import { getLoggedInUserDetails } from "./services/auth";
import EventsStatus from "./pages/EventsStatus";
import Subscriptions from "./pages/Payments/Subscriptions";
import Sponsors from "./pages/Sponsors";
import Learners from "./pages/Learners";
import CommunityForum from "./pages/CommunityForum";
import Feedbacks from "./pages/Feedback";
import Users from "./pages/User";
import ReferralsPage from "./pages/Referral";

const { REACT_APP_API_VERSION, REACT_APP_API_BASE_URL } = process.env;
export default function App() {
  if (!REACT_APP_API_VERSION || !REACT_APP_API_BASE_URL) {
    throw new Error(
      "REACT_APP_API_VERSION or REACT_APP_API_BASE_URL is not defined"
    );
  }
  const { isLoggedIn, setUser } = useUserStore();

  useEffect(() => {
    if (!isLoggedIn) return;
    (async () => {
      const user = await getLoggedInUserDetails();
      setUser(user);
    })();
    // eslint-disable-next-line
  }, [isLoggedIn]);
  return (
    <Router>
      <Routes>
        {/* Dashboard Layout */}
        <Route element={<AppLayout />}>
          <Route
            index
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="/events"
            element={
              <ProtectedRoute>
                <Events />
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="/events/:id/statuses"
            element={
              <ProtectedRoute>
                <EventsStatus />
              </ProtectedRoute>
            }
          />

          <Route
            index
            path="/payment/subscriptions"
            element={
              <ProtectedRoute>
                <Subscriptions />
              </ProtectedRoute>
            }
          />

          <Route
            index
            path="/sponsors"
            element={
              <ProtectedRoute>
                <Sponsors />
              </ProtectedRoute>
            }
          />

          <Route
            index
            path="/sponsors/:sponsorId"
            element={
              <ProtectedRoute>
                <Learners />
              </ProtectedRoute>
            }
          />

          <Route
            index
            path="/community-forum"
            element={
              <ProtectedRoute>
                <CommunityForum />
              </ProtectedRoute>
            }
          />

          <Route
            index
            path="/feedbacks"
            element={
              <ProtectedRoute>
                <Feedbacks />
              </ProtectedRoute>
            }
          />

          <Route
            index
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />

          <Route
            index
            path="/users/:userId/referrals"
            element={
              <ProtectedRoute>
                <ReferralsPage />
              </ProtectedRoute>
            }
          />

          {/* Others Page */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <UserProfiles />
              </ProtectedRoute>
            }
          />

          {/* Forms */}
          <Route
            path="/form-elements"
            element={
              <ProtectedRoute>
                <FormElements />
              </ProtectedRoute>
            }
          />

          {/* Tables */}
          <Route
            path="/basic-tables"
            element={
              <ProtectedRoute>
                <BasicTables />
              </ProtectedRoute>
            }
          />

          {/* Ui Elements */}
          <Route
            path="/alerts"
            element={
              <ProtectedRoute>
                <Alerts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/avatars"
            element={
              <ProtectedRoute>
                <Avatars />
              </ProtectedRoute>
            }
          />
          <Route
            path="/badges"
            element={
              <ProtectedRoute>
                <Badges />
              </ProtectedRoute>
            }
          />
          <Route
            path="/buttons"
            element={
              <ProtectedRoute>
                <Buttons />
              </ProtectedRoute>
            }
          />
          <Route
            path="/images"
            element={
              <ProtectedRoute>
                <Images />
              </ProtectedRoute>
            }
          />
          <Route
            path="/videos"
            element={
              <ProtectedRoute>
                <Videos />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Auth Layout */}
        <Route element={<AuthLayout />}>
          <Route path="/signin" element={<SignIn />} />
        </Route>

        {/* Fallback Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
